// extracted by mini-css-extract-plugin
export default {"list":"VBj1C"};